export default "__VITE_ASSET__CMwee5Xu__"